import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StatisticsBar } from '../../common/components/statistics-bar.component';
import { Theme } from '../../theme/theme';
import { FiltersBar } from '../../common/components/filters-bar.component';
import { DataTable } from '../../common/components/data-table.component';
import TextField from 'material-ui/TextField';
import { ActionMenu } from '../../common/components/action-menu.component';
import { FontAwesome } from '../../common/components/font-awesome';
import { CreateEditManualForm } from './create-edit-manual-form.container';
import { FloatingActionButton } from 'material-ui';
import { YesNoModal } from '../../common/components/yes-no-modal.component';
import { ProfileAvatar } from '../../common/components/profile-avatar.component';

const styles = {
  addButton: {
    float: 'right'
  },
  actionIcon: {
    cursor: 'pointer',
    fontSize: 12,
    marginRight: 10
  },
  table: {
    marginLeft: '3%',
    marginRight: '3%'
  }
};

export class ManualsView extends Component {
  static propTypes = {
    editModalOpen: PropTypes.bool,
    editModeEntity: PropTypes.any,
    statisticsData: PropTypes.any,
    toggleEditMode: PropTypes.func,
    removeManual: PropTypes.func,
    skip: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    search: PropTypes.string.isRequired,
    updateFilter: PropTypes.func.isRequired,
    manuals: PropTypes.shape({
      error: PropTypes.any,
      loading: PropTypes.bool,
      allManuals: PropTypes.shape({
        total: PropTypes.number,
        totalForFilter: PropTypes.number,
        items: PropTypes.arrayOf(PropTypes.any)
      })
    })
  };

  constructor() {
    super();

    this.state = {
      manualToRemove: null,
      manualToManage: null,
      allItems: []
    };
  }

  updatePagination(nextData) {
    if (nextData) {
      this.props.updateFilter({ skip: this.props.skip + this.props.limit });
    } else {
      let newSkip = this.props.skip - this.props.limit;

      if (newSkip < 0) {
        newSkip = 0;
      }

      this.props.updateFilter({ skip: newSkip });
    }
  }

  resetFilter() {
    this.props.updateFilter({ skip: 0, search: '' });
  }

  updateSearch(newValue) {
    this.props.updateFilter({ skip: 0, search: newValue });
  }

  getTitle() {
    if (this.props.editModeEntity) {
      if (Object.keys(this.props.editModeEntity).length === 0) {
        return 'Create Manual';
      }

      if (this.isDisableEditForm(this.props.editModeEntity)) {
        return 'View Manual';
      }

      return 'Edit Manual';
    }

    return '';
  }

  isDisableEditForm(entity = this.props.editModeEntity) {
    return entity && entity.isManual === false;
  }

  removeManual(manual) {
    this.setState({
      manualToRemove: manual
    });
  }

  removeModalResult(doRemove) {
    console.log(doRemove, 'doRemove');
    const manual = this.state.manualToRemove;

    this.setState({
      manualToRemove: null
    });

    if (doRemove) {
      this.props.removeManual(manual.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.manualToManage !== null &&
      nextProps.manuals &&
      nextProps.manuals.allmanuals &&
      nextProps.manuals.allmanuals.items
    ) {
      this.setState({
        manualToManage: nextProps.manuals.allmanuals.items.find(
          manual => manual.id === this.state.manualToManage.id
        )
      });
      this.setState({
        allItems: this.props.manuals.allManuals.items
      });
    }
  }

  getManualStatistics() {
    const { statisticsData } = this.props;
    return [
      {
        name: 'Total Manuals',
        value: statisticsData.totalManuals || 0,
        color: Theme.PRIMARY_COLOR
      }
    ];
  }

  getManualAnalyticsStatistics() {
    const { statisticsData } = this.props;
    console.log('Manual Analytics Statistics Data:', statisticsData);
    return [
      {
        name: 'Total Views',
        value: statisticsData?.totalManualViews || 0,
        color: Theme.PRIMARY_COLOR
      },
      {
        name: 'Avg Views/Manual',
        value: statisticsData?.totalManuals > 0 
          ? Math.round(statisticsData.totalManualViews / statisticsData.totalManuals)
          : 0,
        color: Theme.ACTIVE1_COLOR
      }
    ];
  }

  render() {
    const tableDesc = [
      { headerName: 'Name', width: 20, valueFrom: 'name' },
      { headerName: 'Label', width: 30, valueFrom: 'label' },
      {
        headerName: 'File',
        width: 20,
        render: item => {
          if (item && item.data) {
            return (
              <div>
                <div
                  style={{
                    display: 'inline-block',
                    lineHeight: '30px',
                    verticalAlign: 'top',
                    marginLeft: 5
                  }}
                >
                  <FontAwesome
                    style={styles.actionIcon}
                    onClick={() => {
                      window.open(item.data);
                    }}
                    tooltip={'View File'}
                    name={'file'}
                  />
                </div>
              </div>
            );
          }

          return <span />;
        }
      },

      {
        headerName: 'Actions',
        width: 15,
        rowStyle: {
          overflow: 'visible'
        },
        render: item => {
          const disabled = this.isDisableEditForm(item);

          return (
            <div>
              <FontAwesome
                style={styles.actionIcon}
                onClick={() => this.props.toggleEditMode(item)}
                tooltip={disabled ? 'View' : 'Edit'}
                name={disabled ? 'eye' : 'pencil-square-o'}
              />
              {disabled ? null : (
                <FontAwesome
                  style={styles.actionIcon}
                  onClick={() => this.removeManual(item)}
                  tooltip='Remove'
                  name='trash'
                />
              )}
            </div>
          );
        }
      }
    ];

    const totalForFilter = this.props.manuals.allManuals
      ? this.props.manuals.allManuals.total
      : 0;
    const items = this.props.manuals.allManuals
      ? this.props.manuals.allManuals.items
      : [];

    return (
      <div>
        <YesNoModal
          title='Are you sure?'
          open={this.state.manualToRemove !== null}
          onNo={() => this.removeModalResult(false)}
          onYes={() => this.removeModalResult(true)}
        >
          {this.state.manualToRemove === null ? null : (
            <div>
              Removing the manual{' '}
              <strong>
                {this.state.manualToRemove.fullName}(
                {this.state.manualToRemove.identifier})
              </strong>{' '}
              will also remove the manual from all participants that connected
              to it!
            </div>
          )}
        </YesNoModal>
        <ActionMenu
          onRequestClose={() => this.props.toggleEditMode(null)}
          title={this.getTitle()}
          open={this.props.editModalOpen}
        >
          <CreateEditManualForm
            disabled={this.isDisableEditForm()}
            manual={this.props.editModeEntity}
          />
        </ActionMenu>

        <StatisticsBar data={this.getManualStatistics()} />
        <StatisticsBar data={this.getManualAnalyticsStatistics()} />

        <FiltersBar title='Manuals'>
          <TextField
            hintText='Search Manual'
            value={this.props.search}
            onChange={(event, newValue) => this.updateSearch(newValue)}
          />
          <FloatingActionButton
            style={styles.addButton}
            onClick={() => this.props.toggleEditMode({})}
          >
            <FontAwesome name='plus' />
          </FloatingActionButton>
        </FiltersBar>
        <DataTable
          loading={this.props.manuals.loading}
          skip={this.props.skip}
          limit={this.props.limit}
          total={totalForFilter}
          onNext={() => this.updatePagination(true)}
          onPrev={() => this.updatePagination(false)}
          onResetFilter={() => this.resetFilter()}
          style={styles.table}
          idField='id'
          data={items}
          description={tableDesc}
        />
        <div id='someDiv'></div>
      </div>
    );
  }
}
